import texts from '../book.texts'

class Step3Controller {
    constructor(
        $scope,
        $rootScope,
        $stateParams,
        $timeout,
        config,
        PaginatorFactory,
        User,
        BookFactory,
        Category,
        Share
    ) {
        this.name = 'step3'

        this.$scope = $scope
        this.$rootScope = $rootScope
        this.$stateParams = $stateParams
        this.$timeout = $timeout
        this.config = config

        this.PaginatorFactory = PaginatorFactory
        this.User = User
        this.BookFactory = BookFactory
        this.Category = Category
        this.ShareFactory = Share
        this.transitionEnd = this.transitionEnd.bind(this)

        this.categories = []
        this.selectedCategory = null

        this.texts = texts
    }

    $onInit () {
        this.render()

        this.watchPagesCount()
        this.watchActivePage()
        this.watchLanguage()

        this.getBook()

        this.initializeUser()

        this.bindEvents()
    }

    render () {
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        const {
            CLOSE,
            BEEN_IN_GEORGIA_ONE,
            BEEN_IN_GEORGIA_TWO,
            BY_TOURISTS,
            OWNER_TEXT,
            CURRENT_PAGE_TEXT,
            TOTAL_PAGE_TEXT,
            SWIPE,
            SHARE
        } = texts[this.language]

        this.closeText = CLOSE
        this.beenInGeorgiaOne = BEEN_IN_GEORGIA_ONE
        this.beenInGeorgiaTwo = BEEN_IN_GEORGIA_TWO
        this.byTourists = BY_TOURISTS
        this.ownerText = OWNER_TEXT
        this.currentPageText = CURRENT_PAGE_TEXT
        this.totalPageText = TOTAL_PAGE_TEXT
        this.swipeText = SWIPE
        this.shareText = SHARE
    }

    watchLanguage () {
        this.$scope.$watch(() => localStorage.getItem('tourists_lang'), (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.render()
            }
        })
    }

    initializeUser () {
        const user = this.User.getUser()

        if (user) {
            try {
                const [fullName] = user.fullName.split(' ')

                this.fullName = fullName
            } catch (e) {
                console.log('fullName is undefined', e)
            }
        }
    }

    initializeTurnjs () {
        const postsLength = this.posts.length + 1
        const step3Scope = this

        $('.flipbook').turn({
            // Elevation
            elevation: 50,
            // Enable gradients
            gradients: true,
            // Duration
            duration: 850,
            page: 2,
            when: {
                start: (event, pageObject) => {
                    if (pageObject.next === 1 || pageObject.next > postsLength) {
                        event.preventDefault()
                    }
                },
                turning: (event, page) => {
                    if (page === 1 || page > postsLength) {
                        event.preventDefault()
                    }
                },
                turned: (event, page) => {
                    if (!step3Scope.bookFlipped) {
                        step3Scope.bookFlipped = true
                        return
                    }

                    step3Scope.triggerChange(page, true)
                }
            }
        })

        step3Scope.bookLoaded = true
    }

    isLast (value) {
        if (value) {
            this.initializeTurnjs()
        }
    }

    triggerChange (page, mustApplyScope) {
        const activePage = Math.floor(page / 2)

        this.PaginatorFactory.setActivePageNumber(activePage)
        this.$rootScope.$broadcast('activePageChangeEvent', mustApplyScope)
    }

    getBook () {
        this.posts = []
        this.bookLoaded = false

        this.BookFactory.getBook(this.$stateParams.bookId)
            .then((response) => {
                const {
                    posts,
                    categories,
                    user
                } = response.data

                if (user) {
                    const [fullName] = user.fullName.split(' ')

                    this.bookOwnerFullName = fullName
                }

                const [selectedCategory] = categories

                let prevCardCategory = ''

                this.posts = []

                posts.forEach((item) => {
                    const {
                        category
                    } = item

                    if (category !== prevCardCategory) {
                        prevCardCategory = category

                        this.posts.push({
                            category,
                            cardType: 'layout category'
                        })
                    }

                    this.posts.push(item)
                })

                this.categories = categories.map(item => texts[this.language][item])
                this.selectedCategory = selectedCategory

                this.pagesCount = Math.ceil(this.posts.length / 2)
                this.activePage = 1
                this.bookFlipped = false
                this.PaginatorFactory.setDataReady(true, this.pagesCount, this.activePage)
            })
            .catch((err) => {
                console.log('Error occured in method getBook', err)

                this.error = err.data
            })
    }

    transitionEnd (ev) {
        if (!this.alreadySwiped && ev.activeIndex > 0) {
            this.alreadySwiped = true
        }

        this.currentPostIndex = ev.activeIndex
        this.$scope.$apply()
    }

    bindEvents () {
        const that = this

        $('#book-step3').focus()

        $('.posts').on('click', '.card-wrapper', function click () {
            const activeIndex = (that.activePage * 2) - 1

            if ($(this).hasClass('even') && activeIndex > 1) {
                that.triggerChange(activeIndex - 1, false)
            } else if ($(this).hasClass('odd') && activeIndex < that.posts.length - 1) {
                that.triggerChange(activeIndex + 3, false)
            }
        })
    }

    onKeyUp (event) {
        const activeIndex = (this.activePage * 2) - 1

        if (event.key === 'ArrowLeft' && activeIndex > 1) {
            this.triggerChange(activeIndex - 1, false)
        } else if (event.key === 'ArrowRight' && activeIndex < this.posts.length - 1) {
            this.triggerChange(activeIndex + 3, false)
        }
    }

    selectCategory (newCategory) {
        const category = texts[this.language][newCategory]

        if (this.selectedCategory === category) {
            return
        }

        this.selectedCategory = category

        let page = this.posts.findIndex(item => item.category === category)

        page = page % 2 === 1 ? page + 1 : page + 2

        this.triggerChange(page, false)
    }

    watchPagesCount () {
        this.$scope.$watch(
            () => this.PaginatorFactory.getPagesCount(),
            (newValue) => {
                this.pagesCount = newValue
            }
        )
    }

    watchActivePage () {
        this.$scope.$watch(
            () => this.PaginatorFactory.getActivePageNumber(),
            (newValue) => {
                this.activePage = newValue

                if (this.posts.length > 0) {
                    const activeIndex = (this.activePage * 2) - 1

                    try {
                        this.selectedCategory = this.posts[activeIndex].category
                    } catch (e) {
                        console.log(e)
                    }

                }
            }
        )
    }

    shareGuidebook () {
        const url = `${this.config.frontUrl}/shared-moments/book/step-3?bookId=${this.$stateParams.bookId}`

        this.ShareFactory
            .shareObject(url)
    }
}

Step3Controller.$inject = [
    '$scope',
    '$rootScope',
    '$stateParams',
    '$timeout',
    'config',
    'PaginatorFactory',
    'User',
    'BookFactory',
    'Category',
    'Share'
]

export default Step3Controller



// WEBPACK FOOTER //
// ./client/app/components/home/book/step3/step3.controller.js